import React, { FC, useRef } from "react";
import type { InvestorLatestInsightsProps } from "@/types";
import { Link } from "../link";
import { PostCard } from "../post-card";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const InvestorLatestInsights: FC<InvestorLatestInsightsProps> = ({
  title,
  viewAll,
  readMore,
  posts,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="investorLatestInsights">
      <div className="investorLatestInsights--inner">
        <div className="wrapper">
          <div className="investorLatestInsights--top">
            <SplitTextAnimation
              htmlElement={
                <h2 className="investorLatestInsights--title">{title}</h2>
              }
              isInView={isInView}
            />
            {viewAll.link?.uri && (
              <Link
                href={viewAll.link?.uri}
                noStyle
                className="investorLatestInsights--viewAll"
              >
                {viewAll.text}
              </Link>
            )}
          </div>
          <div className="investorLatestInsights--cards" ref={ref}>
            {posts.map((post, index) => {
              return (
                <PostCard
                  key={index}
                  card={post}
                  readMore={readMore}
                  style={{
                    transform: isInView
                      ? "none"
                      : `translateY(${20 * (index + 1)}px)`,
                    opacity: isInView ? 1 : 0,
                    transition:
                      "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
